import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useRoutesContext } from './routes-context'

// This Route is to be used as a 404 Route that routes up to the parent Router.
// e.g.
// <Router handledExternalRoutes={[{path: '/tree/person'}]}>
//   <MemoryRouter>
//     <Switch>
//       <Route path="/1">
//         <div>
//           <Link to="/tree/person/MMM-MMMM" external>Person</Link>
//         </div>
//       </Route>
//       <Route path="/2"><Two /></Route>
//       <Route path="*"><RouteToParentRouter /></Route>
//     </Switch>
//   </MemoryRouter>
// </Router>
//
export default function RouteToParentRouter() {
  const { history, removeBase } = useRoutesContext()
  const location = useLocation()

  useEffect(() => {
    // Needed so the base isn't added onto absolute relative paths if in handledExternalRoutes.
    // e.g. to="/tree/person/MMM-MMMM" would turn into "/tree/person/tree/person/MMM-MMMM"
    location.pathname = removeBase(location.pathname)
    history.push(location)
  }, [history, location, removeBase])

  return null
}
